import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

function handleMenu() {
  const SideNav = document.querySelector(".SideNav");
  SideNav.style.display = "flex";
}

function handleClose() {
  const SideNav = document.querySelector(".SideNav");
  SideNav.style.display = "none";
}

function NavBar() {

  const handleSideNavLinkClick = () => {
    handleClose();
  };

  return (
    <>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <nav>

        <ul className="SideNav">

          <li className="CloseBtnWrapper">
            <button
              style={{ background: "none", border: "none", cursor: "pointer" }}
              onClick={handleClose}
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </li>

          <li>
            <Link to="/" onClick={handleSideNavLinkClick}>Home</Link>
          </li>

          <li>
            <Link to="/Products" onClick={handleSideNavLinkClick}>Products</Link>
          </li>

          <li>
            <Link to="/Services" onClick={handleSideNavLinkClick}>Services</Link>
          </li>

          <li>
            <Link to="/Contact" onClick={handleSideNavLinkClick}>AboutUs</Link>
          </li>

          <li>
            <Link to="/projects" onClick={handleSideNavLinkClick}>Projects</Link>
          </li>

          {/* Request Quote Button inside mobile menu */}
          <li className="SideNavBtnContainer">
            <button className="QuoteBtn">
              <Link
                to="/Form"
                onClick={handleSideNavLinkClick}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                  display: "block",
                }}
              >
                Request Quote
              </Link>
            </button>
          </li>

        </ul>

        {/* ================= MAIN NAVBAR ================= */}

        <div className="NavWrapper">

          {/* ===== LEFT (LOGO) ===== */}

          <div className="NavLeft">
            <img
              src="/assets/OriginalLogo.png"
              alt="WIP Logo"
              className="Logo"
            />
          </div>

          {/* ===== CENTER LINKS ===== */}

          <ul className="NavCenter">
            <li className="hideOnMobile"><Link to="/">Home</Link></li>
            <li className="hideOnMobile"><Link to="/Products">Products</Link></li>
            <li className="hideOnMobile"><Link to="/Services">Services</Link></li>
            <li className="hideOnMobile"><Link to="/Contact">AboutUs</Link></li>
            <li className="hideOnMobile"><Link to="/projects">Projects</Link></li>
          </ul>

          <div className="NavRight">

            {/* CART ICON */}
            <Link to="/cart" className="CartIcon">
              <span className="material-symbols-outlined">shopping_cart</span>
            </Link>
            <button className="hideOnMobileBtn">
              <Link
                to="/Form"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Request Quote
              </Link>
            </button>

            <div className="Menubtn" onClick={handleMenu}>
              <button>
                <span className="material-symbols-outlined">menu</span>
              </button>
            </div>

          </div>

        </div>

      </nav>
    </>
  );
}

export default NavBar;